import api from "../api";

export default {
    store(event, data) {
        return api.post(`/central/events/${event}/ticket-designs`, data)
    },
    show(id) {
        return api.get(`/central/ticket-designs/${id}`)
    },
    update(id, data) {
        return api.patch(`/central/ticket-designs/${id}`, data)
    }
}
